import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const TableManagerPrepaidByDay = (props) => {
  const { rows } = props || {};

  return rows?.map((row) => (
    <TableRow
      key={row.name}
      sx={{
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }}
    >
      <TableCell align='left' component='th' scope='row'>
        {row.date}
      </TableCell>

      <TableCell align='right'>{row.quantity}</TableCell>
    </TableRow>
  ));
};

export default TableManagerPrepaidByDay;
